<template>
  <v-sheet>

    <v-row no-gutters>
      <v-col cols="6">
      </v-col>
      <v-spacer>
      </v-spacer>
      <v-col cols="3">
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            outlined
            dense
            clearable
            single-line
            hide-details
            class="mb-2"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-sheet outlined>
      <v-data-table
          :headers="headers"
          :items="localData"
          :search="search"
          dense
          fixed-header
          :custom-filter="customFilter"
          class="align-content-left"
          no-data-text="No results available. Please try other site."
          item-key="unique_key"
      >
        <template v-slot:item.URL="{ item }">
          <imgbox :imgurl="item.URL" style="align-content: flex-start"></imgbox>
        </template>

        <template v-slot:item.detail="{ item }">
          <v-sheet>
            <div><strong>Normalized ID:</strong> {{ item.substrate }}:{{ item.harm_site }}</div>
            <div><strong>Original substrate:</strong> {{ item.substrate_original !== null ? item.substrate_original : item.substrate }}</div>
            <div><strong>Original site:</strong> {{ item.original_standarize_site }}</div>
            <div v-if="item.pfocr_url">
              <strong>PFOCR:</strong> <a :href="item.pfocr_url" target="_blank">link</a>
            </div>
            <div v-if="item.pmcid">
              <strong>PMCID:</strong> <a :href="item.pmc_url" target="_blank">{{ item.pmcid }}</a>
            </div>
            <div v-else>
              <strong>PMCID:</strong> N/A
            </div>
            <div v-if="item.pmc_title">
              <strong>PMC Title:</strong> {{ item.pmc_title }}
            </div>
            <div v-else>
              <strong>PMC Title:</strong> N/A
            </div>

            <div v-if="item.organisms">
              <strong>Organisms:</strong> {{ item.organisms }}
            </div>
            <div v-if="item.figuretitle">
              <strong>Figure Title:</strong> {{ item.figuretitle }}
            </div>
            <div v-if="item.signature_name">
              <strong>GPT Summarized Signature Name:</strong> {{ item.signature_name }}
            </div>
          </v-sheet>
        </template>
      </v-data-table>
    </v-sheet>
  </v-sheet>
</template>

<script>
import Imgbox from "@/components/imgbox.vue";

export default {
  name: "DetailFigureTable",
  props: ["tdata"],
  components: {Imgbox},
  data() {
    return {
      search: '',
      localData: [],
      headers: [
        {text: 'Figure', value: 'URL', align: 'start', sortable: false, width: "20%"},
        {text: 'Detail', value: 'detail', align: 'start', sortable: false, width: "80%"},
      ],
    }
  },
  methods: {
    customFilter(value, search, item) {
      if (!search) return true

      const needle = search.toLowerCase()
      return item.search_text
          ?.toLowerCase()
          .includes(needle)
    }
  },
  mounted() {
  },
  watch: {
    tdata: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          this.localData = []
          return
        }

        this.localData = newVal.map((item, index) => ({
          ...item,
          search_text: [
            item.substrate,
            item.harm_site,
            item.figuretitle,
            item.signature_name,
            item.organisms,
            item.pmcid,
            item.pmc_title
          ].filter(Boolean).join(' '),
          unique_key: item.substrate && item.harm_site
              ? `${item.substrate}_${item.harm_site}_${index}`
              : `row_${index}`
        }))
      }
    }
  }
}
</script>

<style type="text/scss" lang="scss" scoped>

</style>